//#region : Imports

import
{
    Component,
    OnInit,
    ViewChild
}
    from '@angular/core';

import
{
    GlobalsService
}
    from '../../globals.service';

import
{
    IMapController,
    GoogleMapController
}
    from './mapview.model';

import
{
    DeviceScans
}
    from '../stats/stats.model';
import
{
    Router
}
    from '@angular/router';

//#endregion

@Component(
    {
        selector: 'app-mapview',
        templateUrl: './mapview.component.html',
        styleUrls: ['./mapview.component.css']
    })
export class MapViewComponent implements OnInit
{
    public mapController: IMapController | undefined;
    public static instance;

    constructor(private globals: GlobalsService, private router: Router)
    {
        MapViewComponent.instance = this;

        this.globals.currentPage = "map";
    }

    onMapReady(map: any)
    {
        //Initialize the map controller
        this.mapController = new GoogleMapController(map);
        this.mapController.setMapFeatures(false, true, true, true);
        this.mapController.setZoom(5);


        //If analytics component is hidden then devices will be zero. Do devicelist
        if (this.globals.deviceScans && this.globals.deviceScans.length == 0 && !this.globals.buildSettings.showDevTab) {

            //Get models
        let models: any = this.globals.getModels();
            this.globals.deviceList(undefined, models, undefined, undefined, (devices: any) =>
        {
        
            this.globals.deviceScans = devices;
                this.globals.loading = false;
                MapViewComponent.refresh();
                
            
        });


         }
        else {MapViewComponent.refresh(); }

        
    }

    ngOnInit()
    {

    }

    ngAfterViewInit()
    {

    }

    public static refresh()
    {
        let me: MapViewComponent = MapViewComponent.instance;

        if (me && me.mapController)
        {
            me.mapController.clearMarkers();
            let deviceScans: DeviceScans[] = me.globals.deviceScans;



            for (var i = 0; i < deviceScans.length; i++)
            {
                let device: any = deviceScans[i];
                let scan: DeviceScans = deviceScans[i];

                if (device && device.state && device.state.position)
                {
                    let pos: any = device.state.position;

                    me.mapController.addMarker(device.snr, device.name, pos.latitude, pos.longitude, scan.totalScans, scan.estAlarmCount);
                }
            }

            me.mapController.zoomFit();
        }
    }

    public static goto(lat: number, lng: number, snr: string)
    {
        let me: MapViewComponent = MapViewComponent.instance;

        if (me && me.mapController)
        {
            me.mapController.select(lat, lng, snr);
            me.mapController.setCenter(lat, lng);
            me.mapController.setZoom(15);
        }
    }

    routeToAnalytics()
    {
        this.router.navigate(['analytics']);
    }
}